<!-- <i class="flaticon-close" (click)="closeDialog()"></i> -->
<mat-form-field appearance="outline" fxFlex="100">
    <input matInput type="text" placeholder="Search by Port/Country/Region name" [ngModel]="_searchText"
        (ngModelChange)="searchPorts($event)">
</mat-form-field>

<div class="ports-tab" fxFlex="100">
    <span (click)="showSelectedList=false" [class.active]="!showSelectedList"
        [ngClass]="{'smallText':authService.defaultFontSize==='small','mediumText':authService.defaultFontSize==='medium','largeText':authService.defaultFontSize==='large'}">Choose
        Locations</span>
    <span (click)="showSelectedList=true" [class.active]="showSelectedList">Selected Locations ({{ports.length}})</span>
</div>

<div class="selectLocation" *ngIf="!showSelectedList" fxFlex="100">

    <div *ngFor="let option of options; let idx=index" class="checkbox-container"
        [class.is-last]="idx == options.length - 1" [class.disabled]="option.ports.length == 0">
        <div class="checkbox-wrapper">
            <mat-checkbox color="primary" class="checkbox-option name-wrapper" [disabled]="option.ports.length == 0"
                [checked]="isRegionSelected(option)" [indeterminate]="isRegionIndeterminate(option)"
                (change)="regionClicked($event.checked, option)">
                <span class="location-name">
                    {{option.name}}
                </span>
            </mat-checkbox>
        </div>

        <div [ngSwitch]="option.type" class="icon">
            <i *ngSwitchCase="'region'" class="flaticon-world-map"
                [matTooltip]="'Region With ' + option.ports.length + ' Ports'"
                [class.active]="isRegionSelected(option)"></i>
            <i *ngSwitchCase="'port'" class="flaticon-anchor" matTooltip="Port"
                [class.active]="isRegionSelected(option)"></i>
            <i *ngSwitchCase="'country'" class="flaticon-flag"
                [matTooltip]="'Country With ' + option.ports.length + ' Ports'"
                [class.active]="isRegionSelected(option)"></i>
        </div>
        <div class="name-wrapper"
            (click)="option.expanded = !option.expanded && option.ports.length && option.type != 'port'">
            <span class="caret" *ngIf="(option.type == 'region' || option.type == 'country')&& option.ports.length">
                <!-- <mat-icon *ngIf="option.expanded">keyboard_arrow_down</mat-icon>
        <mat-icon *ngIf="!option.expanded">keyboard_arrow_right</mat-icon> -->
                <i class="flaticon-down-chevron" [class.rRight]="!option.expanded"></i>
            </span>
            <!-- <span class="location-name">
              {{option.name}}
            </span> -->
        </div>
        <div class="option-ports" [class.expandPort]="option.expanded">
            <div *ngFor="let port of option.ports; let idx=index" class="port-wrapper"
                [class.is-last]="idx == option.ports.length - 1">
                <div class="checkbox-wrapper">
                    <mat-checkbox color="primary" class="checkbox-option name-wrapper"
                        (change)="portClicked($event.checked, port)" [checked]="isPortAlreadyAdded(port)"><span
                            class="location-name">
                            {{port.name}}
                        </span></mat-checkbox>
                </div>
                <div class="icon">
                    <i class="flaticon-anchor" [class.active]="isPortAlreadyAdded(port)" matTooltip="Port"></i>
                </div>
                <!-- <div class="name-wrapper">
                  <span class="location-name">
                    {{port.name}}
                  </span>
                </div> -->
                <div class="hint">
                    <div>Select Port</div>
                </div>
            </div>
        </div>
        <div class="hint" [ngSwitch]="option.type">
            <div *ngSwitchCase="'region'">
                <span *ngIf="option.ports.length" class="withDropdown"> {{selectedPortsForRegion(option)}} of
                    {{option.ports.length}} ports selected in
                    region</span>
                <span *ngIf="option.ports.length == 0">No serviceable ports found in region</span>
            </div>
            <div *ngSwitchCase="'port'">Select Port</div>
            <div *ngSwitchCase="'country'">
                <span *ngIf="option.ports.length" class="withDropdown"> {{selectedPortsForRegion(option)}} of
                    {{option.ports.length}} ports selected in
                    country</span>
                <span *ngIf="option.ports.length == 0">No serviceable ports found in country</span>
            </div>
        </div>

    </div>
    <div *ngIf="options.length == 0" class="dataLoader">
        <i class="flaticon-search" *ngIf="dataStatement != 'No Location Found'"></i>
        <span>{{dataStatement}}</span>
    </div>

</div>

<div *ngIf="showSelectedList" class="selectedList" fxFlex="100">
    <!-- <div class="regions-list"></div>
    <div class="countries-list"></div> -->
    <div class="ports-list">
        <div *ngFor="let port of ports" class="port-wrapper">
            <div class="checkbox-wrapper">
                <i class="flaticon-anchor" matTooltip="Port"></i>
                <span class="port-list-name">{{port.name}}</span>
            </div>
            <div class="icon">
                <i class="flaticon-close delete" (click)="removePort(port)"></i>
            </div>
        </div>
        <div class="noPorts" *ngIf="ports.length===0">
            <span>No Ports selected.</span>
        </div>

    </div>
</div>
<div class="confirm-btn-wrapper" fxFlex="100">
    <button mat-raised-button class="Save" (click)="closeDialog()">Done</button>
</div>